import {ChangeDetectionStrategy, Component, ElementRef, input, output, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UiIconComponent} from '../ui-icon/ui-icon.component';

@Component({
  selector: 'app-ui-button',
  templateUrl: './ui-button.component.html',
  styleUrls: ['./ui-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, UiIconComponent],
})
export class UiButtonComponent {
  color = input<
    | 'primary'
    | 'baba'
    | 'secondary'
    | 'tertiary'
    | 'green'
    | 'lightgreen'
    | 'apricot'
    | 'flat'
    | 'ghost'
    | 'outline'
    | 'outline-green'
    | 'outline-tertiary-green'
    | 'outline-tertiary'
  >('primary');

  size = input<'xs' | 'sm' | 'md' | 'lg'>('md');
  disabled = input<boolean>(false);
  expanded = input<'inline' | 'block' | 'pill' | 'bullet'>('inline');
  compressed = input<boolean>(false);
  hold = input<boolean>(false);
  linkUrl = input<string>('');
  linkTitle = input<string>('');
  linkClass = input<string>('');
  buttonClass = input<string>('');
  spinner = input<boolean>(false);
  linkTarget = input<'_blank' | '_self' | '_parent' | '_top' | string>('_self');
  onClick = output<Event>();

  @ViewChild('button')
  button: ElementRef<HTMLButtonElement> | undefined;
}
